import InvestmentSelectionComponent from './InvestmentSelectionContainer';

export default InvestmentSelectionComponent;
